// Common constants for the salon management system

// Re-export currency utilities for easy access
export * from '../utils/currency';

export const COMPANY_HEADER = {
  NAME: 'ClickLook by JSNSOFT',
  EMAIL: 'info@clicklooks.com',
  PHONE: '+91 85550 86630',
  STATE_NAME: 'Telangana',
  GST_NUMBER: '36AAKFJ5449E1Z7',
  GST_NAME: 'JSNSOFT',
  WEBSITE: 'https://clicklooks.in', 
};

export const SERVICE_CATEGORIES = {
  HAIR_CUT: 'Hair Cut',
  HAIR_COLOR: 'Hair Color',
  HAIR_STYLING: 'Hair Styling',
  FACIAL: 'Facial',
  MASSAGE: 'Massage',
  MANICURE: 'Manicure',
  PEDICURE: 'Pedicure',
  WAXING: 'Waxing',
  OTHER: 'Other',
};

// Array format for dropdowns and iterations
export const SERVICE_CATEGORIES_LIST = Object.values(SERVICE_CATEGORIES);

export const PRODUCT_CATEGORIES = {
  HAIR_CARE: 'Hair Care',
  SKIN_CARE: 'Skin Care',
  STYLING_PRODUCTS: 'Styling Products',
  HAIR_COLOR: 'Hair Color',
  TOOLS_EQUIPMENT: 'Tools & Equipment',
  NAIL_CARE: 'Nail Care',
  OTHER: 'Other',
};

export const PRODUCT_CATEGORIES_LIST = Object.values(PRODUCT_CATEGORIES);

export const EXPENSE_CATEGORIES = {
  RENT: 'Rent',
  UTILITIES: 'Utilities',
  SUPPLIES: 'Supplies',
  EQUIPMENT: 'Equipment',
  MARKETING: 'Marketing',
  INSURANCE: 'Insurance',
  PROFESSIONAL_SERVICES: 'Professional Services',
  MAINTENANCE: 'Maintenance',
  STAFF: 'Staff',
  OTHER: 'Other',
};

export const EXPENSE_CATEGORIES_LIST = Object.values(EXPENSE_CATEGORIES);

export const PAYMENT_METHODS = {
  CASH: 'Cash',
  CREDIT_CARD: 'Credit Card',
  DEBIT_CARD: 'Debit Card',
  BANK_TRANSFER: 'Bank Transfer',
  CHECK: 'Check',
  OTHER: 'Other',
};

export const PAYMENT_METHODS_LIST = Object.values(PAYMENT_METHODS);

export const STATUS_OPTIONS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const APPOINTMENT_STATUS = {
  SCHEDULED: 'scheduled',
  CONFIRMED: 'confirmed',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  NO_SHOW: 'no_show',
};

// Status color definitions - unified across the application
export const STATUS_COLORS = {
  scheduled: { mui: 'warning', hex: '#FFC107', bg: '#fff8e1' },      // Yellow/Amber for scheduled
  confirmed: { mui: 'info', hex: '#2196F3', bg: '#e3f2fd' },         // Blue for confirmed
  inProgress: { mui: 'secondary', hex: '#9C27B0', bg: '#f3e5f5' },   // Purple for in progress
  completed: { mui: 'success', hex: '#4CAF50', bg: '#e8f5e8' },      // Green for completed
  cancelled: { mui: 'error', hex: '#F44336', bg: '#ffebee' },        // Red for cancelled
  noShow: { mui: 'default', hex: '#9E9E9E', bg: '#f5f5f5' },         // Grey for no show
  default: { mui: 'default', hex: '#757575', bg: '#f5f5f5' },        // Default grey
};

export const APPOINTMENT_STATUS_LIST = [
  { 
    value: APPOINTMENT_STATUS.SCHEDULED, 
    label: 'Scheduled', 
    color: 'warning',  // For Material-UI chips
    statusColor: STATUS_COLORS.scheduled 
  },
  { 
    value: APPOINTMENT_STATUS.CONFIRMED, 
    label: 'Confirmed', 
    color: 'info',     // For Material-UI chips
    statusColor: STATUS_COLORS.confirmed 
  },
  { 
    value: APPOINTMENT_STATUS.IN_PROGRESS, 
    label: 'In Progress', 
    color: 'secondary', // For Material-UI chips
    statusColor: STATUS_COLORS.inProgress 
  },
  { 
    value: APPOINTMENT_STATUS.COMPLETED, 
    label: 'Completed', 
    color: 'success',  // For Material-UI chips
    statusColor: STATUS_COLORS.completed 
  },
  { 
    value: APPOINTMENT_STATUS.CANCELLED, 
    label: 'Cancelled', 
    color: 'error',    // For Material-UI chips
    statusColor: STATUS_COLORS.cancelled 
  },
  { 
    value: APPOINTMENT_STATUS.NO_SHOW, 
    label: 'No Show', 
    color: 'default',  // For Material-UI chips
    statusColor: STATUS_COLORS.noShow 
  },
];

export const INVOICE_STATUS = {
  DRAFT: 'draft',
  SENT: 'sent',
  PAID: 'paid',
  OVERDUE: 'overdue',
  CANCELLED: 'cancelled',
};

export const INVOICE_STATUS_LIST = [
  { value: INVOICE_STATUS.DRAFT, label: 'Draft', color: 'default' },
  { value: INVOICE_STATUS.SENT, label: 'Sent', color: 'info' },
  { value: INVOICE_STATUS.PAID, label: 'Paid', color: 'success' },
  { value: INVOICE_STATUS.OVERDUE, label: 'Overdue', color: 'error' },
  { value: INVOICE_STATUS.CANCELLED, label: 'Cancelled', color: 'error' },
];

export const EXPENSE_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  PAID: 'paid',
  REJECTED: 'rejected',
};

export const EXPENSE_STATUS_LIST = [
  { value: EXPENSE_STATUS.PENDING, label: 'Pending', color: 'warning' },
  { value: EXPENSE_STATUS.APPROVED, label: 'Approved', color: 'success' },
  { value: EXPENSE_STATUS.PAID, label: 'Paid', color: 'success' },
  { value: EXPENSE_STATUS.REJECTED, label: 'Rejected', color: 'error' },
];

export const GENDER_OPTIONS = {
  MALE: 'male',
  FEMALE: 'female',
  OTHER: 'other', 
};

export const GENDER_OPTIONS_LIST = [
  { value: '', label: 'Select Gender' },
  { value: GENDER_OPTIONS.MALE, label: 'Male' },
  { value: GENDER_OPTIONS.FEMALE, label: 'Female' },
  { value: GENDER_OPTIONS.OTHER, label: 'Other' },
  
];

// Utility functions
export const getStatusColor = (status, statusList) => {
  const statusOption = statusList.find(opt => opt.value === status);
  return statusOption ? statusOption.color : 'default';
};

export const getStatusLabel = (status, statusList) => {
  const statusOption = statusList.find(opt => opt.value === status);
  return statusOption ? statusOption.label : status;
};
